// extracted by mini-css-extract-plugin
export default {"cells":"OfferRowUser_cells__NtJj3","status":"OfferRowUser_status__+J-Dq"};